import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { TimelineNoteModalComponent } from '../../../shared/modals/timeline-note-modal/timeline-note-modal.component';
import { OwnerEntityType } from '../../enums/owner-entity-type-enum';

@Injectable({
  providedIn: 'root'
})
export class TimelineNoteModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(timeLineItemModel: any,  disableModel: boolean, ownerEntityType?: OwnerEntityType, otherModel?: any) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( TimelineNoteModalComponent, { windowClass : "customModalClassCentered", size: 'xl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.timelineItem = timeLineItemModel;
    modalRef.componentInstance.disableModel = disableModel;
    if(ownerEntityType){
      modalRef.componentInstance.ownerEntityType = ownerEntityType; 
    }
    if(otherModel){
      modalRef.componentInstance.otherModel = otherModel; 
    }
    var sub: Subscription =  modalRef.closed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.confirmReject);
      sub.unsubscribe();
    })
    var sub: Subscription =  modalRef.dismissed.subscribe(()=>{
      this.modelChanged.emit(modalRef.componentInstance.confirmReject);
      sub.unsubscribe();
    })
  }
}
